import React from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import mockupImage from "../../../images/webtechhome/websiteredesing.png";

const DeviceMockup: React.FC = () => {
  const { scrollY } = useScroll();
  const y = useTransform(scrollY, [0, 400], [0, 24]);
  const glowScale = useTransform(scrollY, [0, 400], [1, 1.08]);

  return (
    <motion.div
      className="wred-mockup"
      style={{ y }}
      initial={{ opacity: 0, scale: 0.94 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.8, delay: 0.35, ease: [0.22, 1, 0.36, 1] }}
      aria-hidden="true"
    >
      <motion.div className="wred-mockup__glow wred-mockup__glow--blue" style={{ scale: glowScale }} />
      <motion.div className="wred-mockup__glow wred-mockup__glow--orange" style={{ scale: glowScale }} />

      <motion.div
        className="wred-mockup__device"
        animate={{ y: [0, -14, 0] }}
        transition={{ duration: 5.5, repeat: Infinity, ease: "easeInOut" }}
      >
        <img
          src={mockupImage}
          alt=""
          className="wred-mockup__image"
          width={720}
          height={540}
          loading="eager"
          decoding="async"
        />
      </motion.div>
    </motion.div>
  );
};

export default DeviceMockup;
